<template>
  <div class="profile">
    <Header />

    <div class="main">
      <Content />
      <!-- <h4>En Mantenimiento</h4>
      <img src="@/assets/config/config.svg" alt="" /> -->
    </div>

    <!-- 
    <h3>Hola mundo</h3> -->

    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/layout/Footer.vue";
import Header from "../../components/private/Header";
import Content from "./components/Content.vue";

export default {
  components: {
    Header,
    Content,
    Footer,
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  margin-bottom: 30px;
}

h4 {
  text-align: center;
  color: #052333;
  font-weight: bold;
}
</style>
